import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { WebSocketContext } from '@/contexts/WebSocketContext';
import { CMDPsTokenUpdate } from '@/models/cmd/live';
import {
    GA_EVENT_CATEGORY,
    GA_LOBBY_EVENT_NAME,
    getNavTab,
    sendGA,
} from '@/utils/ga';
import { IconButton } from '@mui/material';
import { motion } from 'framer-motion';
import { SVGProps, useContext, useState } from 'react';
const updateBalance = new CMDPsTokenUpdate();
export const RefreshBalance = (props: SVGProps<SVGSVGElement>) => {
    const [block, setBlock] = useState<boolean>(false);
    const { sendCommand } = useContext(WebSocketContext);
    const [rotate, setRotate] = useState(0);
    const { playButtonAudio } = useContext(AudioPlayContext);
    const onClickHandler = () => {
        if (block) return;
        setBlock(true);
        playButtonAudio();
        sendCommand(updateBalance);
        setRotate(r => r - 720);
        const currentPage = getNavTab();
        sendGA(
            GA_LOBBY_EVENT_NAME.REFRESH_BAL,
            GA_EVENT_CATEGORY.ENGAGEMENT,
            currentPage
        );
        setTimeout(() => {
            setBlock(false);
        }, 1000);
    };
    return (
        <IconButton
            onClick={onClickHandler}
            sx={{
                padding: 0,
                width: '100%',
                height: '100%',
                '&.MuiButtonBase-root:hover': {
                    bgcolor: 'transparent',
                },
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
                width="100%"
                height="100%"
                fill="none"
                {...props}
            >
                <motion.path
                    d="M23.6854 11.7882L20.6009 14.8882C20.2471 15.2437 20.4903 15.8437 20.9878 15.8437H22.9668C22.9668 19.5215 19.9928 22.5104 16.3335 22.5104C15.4601 22.5104 14.6088 22.3437 13.846 22.0215C13.448 21.8548 12.9947 21.9771 12.6962 22.2771C12.1324 22.8437 12.3314 23.7993 13.0721 24.0993C14.0782 24.5104 15.1837 24.7326 16.3335 24.7326C21.22 24.7326 25.1778 20.7548 25.1778 15.8437H27.1568C27.6543 15.8437 27.8975 15.2437 27.5437 14.8993L24.4592 11.7993C24.2492 11.5771 23.8954 11.5771 23.6854 11.7882ZM9.70018 15.8437C9.70018 12.1659 12.6741 9.17706 16.3335 9.17706C17.2068 9.17706 18.0581 9.34372 18.8209 9.66595C19.2189 9.83261 19.6722 9.71039 19.9707 9.41039C20.5345 8.84372 20.3355 7.88817 19.5948 7.58817C18.5888 7.17706 17.4832 6.95483 16.3335 6.95483C11.4469 6.95483 7.48909 10.9326 7.48909 15.8437H5.51016C5.01266 15.8437 4.76944 16.4437 5.12322 16.7882L8.20769 19.8882C8.4288 20.1104 8.77152 20.1104 8.99263 19.8882L12.0771 16.7882C12.4198 16.4437 12.1766 15.8437 11.6791 15.8437H9.70018Z"
                    fill="#E2B875"
                    animate={{ rotate: rotate }}
                    transition={{
                        repeat: 0,
                        repeatType: 'loop',
                        duration: 1,
                    }}
                />
            </svg>
        </IconButton>
    );
};
